import onUcmaNotification from './onUcmaNotification';
import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import signInIM from './signInIM';

let isNotificationSubscribed = false;

export default function initializeUcma() {
    if (!isNotificationSubscribed) {
        const subscription: NotificationSubscription = {
            subscriptionId: 'InstantMessageNotification',
            requiresExplicitSubscribe: true,
            subscriptionParameters: {
                NotificationType: 'InstantMessageNotification',
            },
        };

        lazySubscribe.importAndExecute(subscription, onUcmaNotification).then(() => {
            isNotificationSubscribed = true;
            signInIM(false /*signedInManually*/);
        });
    } else {
        signInIM(false /*signedInManually*/);
    }
}
